"use client";
import SheetModal from "@/components/ui/sheet-modal";
import CreateWorkerProfile from "@/components/views/modals/create-profile/parts/FirstPart";
import LoginModal from "../login/LoginModal";
import { useState } from "react";
import { useSession } from "next-auth/react";
import EndingPart from "./parts/LastPart";
import AuthModal from "../auth/AuthModal";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function CreateWorkerProfileModal(props: Props) {
  const { status } = useSession();
  const [step, setStep] = useState(0);

  return (
    <>
      {status === "authenticated" ? (
        <SheetModal isOpen={props.isOpen} onClose={props.onClose}>
          <div className="py-4 rounded-tl-3xl rounded-tr-3xl items-center gap-2 inline-flex">
            <span className="text-gray-400 text-sm font-bold font-['DM Sans']">
              Sen de profil oluşturarak aramıza katıl!
            </span>
          </div>

          <div className="flex flex-col gap-4 pt-4 pb-6">
            {step === 0 && (
              <CreateWorkerProfile handleNextStep={() => setStep(step + 1)} />
            )}
            {step === 1 && <EndingPart onClose={props.onClose} />}
          </div>
        </SheetModal>
      ) : (
        <AuthModal initialModal="login" isOpened={props.isOpen} closer={() => props.onClose()} />
      )}
    </>
  );
}
